import * as React from 'react';
import RadioMUI, { RadioProps } from '@mui/material/Radio';
import cn from 'classnames';

import { useTheme } from '../../theme';

const Radio = React.forwardRef<HTMLButtonElement, RadioProps>(({ classes, disableRipple = true, ...props }, ref) => {
	const { Radio: css } = useTheme('Radio');

	return (
		<RadioMUI
			{...props}
			classes={{
				...classes,
				root: cn(classes?.root, css.root, css.additional_class),
				checked: cn(classes?.checked, css.checked),
				disabled: cn(classes?.disabled, css.disabled)
			}}
			disableRipple={disableRipple}
			ref={ref}
		/>
	);
});

export default Radio;
